<template>
	<div>
		<div class="filter-inline-panel cle">
			<el-form :inline="true" size="mini" :model="filters" class="filter-panel fl">
				<el-form-item :label="$t('news_index.type')" prop="type">
					<el-select v-model="filters.type" class="w100" :placeholder="$t('index.pleaseInput')">
						<el-option :label="$t('index.whole')" value=""></el-option>
						<el-option :label="lang=='cn'?item.name_cn:item.name" :value="item.code" v-for="(item,index) in ARTICLE_TYPE" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="mini" @click="sousuo">{{$t('index.query')}}</el-button>
					<el-button type="" size="mini" @click="chongxzhi">{{$t('index.reset')}}</el-button>
				</el-form-item>
			</el-form>
			<div class="list-opinion fr">
				<el-button type="primary" size="mini" @click="add()" v-if="hasBtn('add')">{{$t('index.add')}}</el-button>
			</div>
		</div>
		<el-table :data="list" border row-key="id" size="mini" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
			<el-table-column :prop="lang=='cn'?'title_cn':'title'" align="center" :label="$t('news_index.title')"></el-table-column>
			<el-table-column prop="type" align="center" :label="$t('news_index.type')" :formatter="type_f"></el-table-column>
			<el-table-column :prop="lang=='cn'?'description_cn':'description'" align="center" :label="$t('news_index.description')"></el-table-column>
			<el-table-column prop="sort" align="center" :label="$t('index.sort')"></el-table-column>
			<!-- <el-table-column :prop="lang=='cn'?'content_cn':'content'" align="center" :label="$t('news_index.content')" :formatter="content_f"></el-table-column> -->
			<el-table-column prop="image" align="center" :label="$t('news_index.image')">
				<template slot-scope="scope">
					<el-image style="width: 100px; height: 100px" v-if="scope.row.image" :src="scope.row.image" :preview-src-list="[scope.row.image]" fit="contain"></el-image>
					<span v-if="!scope.row.image">{{$t('index.image_wu')}}</span>
				</template>
			</el-table-column>
			<el-table-column :label="$t('index.operation')" align="center"  fixed="right" width="160">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" v-if="hasBtn('edit')" @click="add(scope.row)">{{$t('index.edit')}}</el-button>
					<el-button size="mini" type="danger" v-if="hasBtn('del')" @click="del(scope.row)">{{$t('index.del')}}</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="page-pagination">
			<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pager-count="5"></el-pagination>
		</div>
		<el-dialog :title="$t('index.dialog_title')" width="1200px" :close-on-click-modal="false" :visible="editFormVisible" @close="editFormVisible = false">
			<el-form :model="editForm" size="mini" label-width="80px" label-position="top" :rules="editFormRules" ref="editForm">
				<el-row class="tree-content" :gutter="20">
					<el-col :span="12">
						<el-form-item :label="$t('index.cn')+$t('news_index.title')" prop="title_cn">
							<el-input v-model="editForm.title_cn" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('index.en')+$t('news_index.title')"  prop="title">
							<el-input v-model="editForm.title" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('index.cn')+$t('news_index.description')" prop="description_cn">
							<el-input v-model="editForm.description_cn" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('index.en')+$t('news_index.description')" prop="description">
							<el-input v-model="editForm.description" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('news_index.jump_type')" prop="jump_type">
							<el-select v-model="editForm.jump_type" class="w100" clearable :placeholder="$t('index.select')">
								<el-option :label="lang=='cn'?item.name_cn:item.name" :value="item.code" v-for="(item,index) in TYPE" :key="index"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('news_index.jump_id')" prop="jump_id">
							<el-input v-model="editForm.jump_id" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('news_index.type')" prop="type">
							<el-select v-model="editForm.type" class="w100" :placeholder="$t('index.select')">
								<el-option :label="lang=='cn'?item.name_cn:item.name" :value="item.code" v-for="(item,index) in ARTICLE_TYPE" :key="index"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('index.sort')" prop="sort">
							<el-input v-model="editForm.sort" :placeholder="$t('index.pleaseInput')" class="w100"></el-input>
						</el-form-item>
					</el-col>
					<!-- <el-col :span="12" v-if="is_co==1">
						<el-form-item :label="$t('news_index.news')" prop="country">
							<el-select v-model="editForm.country" class="w100" :placeholder="$t('index.select')">
								<el-option :label="lang=='cn'?item.name_cn:item.name" v-if="item.code!='co'" :value="item.code" :key="index" v-for="(item,index) in DATA_RIGHTS"></el-option>
							</el-select>
						</el-form-item>
					</el-col> -->
				</el-row>
				<el-row class="tree-content" :gutter="20" v-if="editForm.type=='video'">
					<el-col :span="12">
						<el-form-item :label="$t('news_index.video')" prop="video">
							<el-input v-model="editForm.video" placeholder="" class="w100"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('news_index.cate')" prop="cate">
							<el-select v-model="editForm.cate" class="w100" clearable :placeholder="$t('index.select')">
								<el-option :label="lang=='cn'?item.name_cn:item.name" :value="item.code" v-for="(item,index) in VIDEO_SORT" :key="index"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('news_index.is_top')" prop="is_top">
							<el-radio-group v-model="editForm.is_top">
							    <el-radio :label="1">是</el-radio>
							    <el-radio :label="0">否</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="tree-content" :gutter="20">
					<el-col :span="12">
						<el-form-item :label="$t('news_index.image')" prop="image">
							<upload :value="editForm.image" name="company" @callback="function(res, file){imageSuccess(res, file,'image')}"></upload>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="tree-content" :gutter="20">
					<el-col :span="12">
						<el-form-item :label="$t('index.cn')+$t('news_index.content')" prop="content_cn">
							<editor-bar v-model="editForm.content_cn" :isClear="isClear"></editor-bar>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('index.en')+$t('news_index.content')" prop="content">
							<editor-bar v-model="editForm.content" :isClear="isClear"></editor-bar>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
// import EditorBar from '../../components/wangEnduit.vue'
export default {
	computed: {
		editFormRules(){
			return{
				title: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.en')+this.$t('news_index.title'),
					trigger: 'blur'
				}],
				title_cn: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.cn')+this.$t('news_index.title'),
					trigger: 'blur'
				}],
				description: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.en')+this.$t('news_index.description'),
					trigger: 'blur'
				}],
				description_cn: [{
					required: true,
					message:this.$t('index.pleaseInput')+this.$t('index.cn')+this.$t('news_index.description'),
					trigger: 'blur'
				}],
				type: [{
					required: true,
					message: this.$t('index.select') + this.$t('news_index.type'),
					trigger: 'change'
				}],
				// country: [{
				// 	required: true,
				// 	message: this.$t('index.select') + this.$t('news_index.news'),
				// 	trigger: 'change'
				// }],
			}
		},
	},
	components: {
		// EditorBar
	},
	data() {
		return {
			is_co:sessionStorage.getItem('is_co'),
			image_up: process.env.API_UP,
			list: [],
			editFormVisible: false,
			editForm: {
			},
			image: '',
			filters: {
				type: '',
			},
			pages: {
				page: 1,
				count: 0,
				perpage: 10,
			},
			DATA_RIGHTS:[],
			ARTICLE_TYPE:[],
			VIDEO_SORT:[],
			TYPE:[],
			isClear:false,
		}
	},
	// 初始事件
	mounted: function () {
		this.config();
		this.init();
	},
	// 事件
	methods: {
		config(){
			var this_ = this;
			var url = "getDictionaryValue";
			var datas = {
				code:"DATA_RIGHTS,ARTICLE_TYPE,TYPE,VIDEO_SORT"
			};
			this_.$post(url, datas).then((res) => {
				this_.DATA_RIGHTS = res.DATA_RIGHTS;
				this_.ARTICLE_TYPE = res.ARTICLE_TYPE;
				this_.VIDEO_SORT = res.VIDEO_SORT;
				this_.TYPE = res.TYPE;
			})
		},
		// 初始化
		init() {
			var this_ = this;
			var url = "articleList";
			var datas = {
				type: this_.filters.type,
				page: this_.pages.page,
				num: this_.pages.perpage,
			};
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count = res.sum;
			})
		},
		add(data) {
			this.image='';
			if (data) {
				this.editForm = JSON.parse(JSON.stringify(data));
			} else {
				this.editForm = {
					title: '',
					title_cn: '',
					type: '',
					jump_type: '',
					jump_id: '',
					image: '',
					video: '',
					cate: '',
					is_top:0,
					content: '',
					content_cn: '',
					description: '',
					description_cn: '',
					sort: '',
					// country: '',
				}
			}
			if (this.$refs.editForm) {
				this.$refs.editForm.resetFields();
			}
			this.editFormVisible = true;
		},
		// 保存
		editSubmit(editForm) {
			var this_ = this;
			this_.$refs.editForm.validate((valid) => {
				if (valid) {
					var datas = {
						title_cn: this_.editForm.title_cn,
						title: this_.editForm.title,
						type: this_.editForm.type,
						video: this_.editForm.video,
						cate: this_.editForm.cate,
						is_top: this_.editForm.is_top,
						content_cn: this_.editForm.content_cn,
						content: this_.editForm.content,
						description: this_.editForm.description,
						description_cn: this_.editForm.description_cn,
						jump_type: this_.editForm.jump_type,
						jump_id: this_.editForm.jump_id,
						sort: this_.editForm.sort,
						country:'us',
					}
					if (this_.image) {
						datas['image'] = this_.image;
					}
					var url = "articleAction";
					var tishi = this_.$t('index.add_success');
					if (this_.editForm.id) {
						datas['id'] = this_.editForm.id;
						tishi = this_.$t('index.modify_success');
					}
					this_.$post(url, datas).then((res) => {
						this_.$message.success(tishi);
						this_.editFormVisible = false;
						this_.init();
					});
				} else {
					return false;
				}
			})
		},
		imageSuccess(res, file, name) {
			if (res.status == 200) {
				this.editForm[name] = res.data.showname;
				this.image = res.data.savename;
				this.$refs.editForm.clearValidate(name);
			} else {
				this.$message.success(res.message);
			}
		},
		// 删除
		del(data) {
			var this_ = this;
			var url = "articleDelete";
			var datas = {
				id: data.id
			};
			this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.init();
				})
			}).catch(() => {});
		},
		type_f(w, s, d) {
			var this_ = this;
			var list=this_.ARTICLE_TYPE;
			var name='';
			list.forEach(function(e,i) {
				if (e.code==d) {
					name=this_.lang=='cn'?e.name_cn:e.name;
				}
			});
			return name
		},
		content_f(w,s,d){
			return d.substring(0,50)+'...';
		},
		// 搜索
		sousuo() {
			this.pages.page = 1;
			this.init();
		},
		// 重置
		chongxzhi() {
			this.filters.type = '';
			this.pages.page = 1;
			this.init();
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		}
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.filter-inline-panel {
	/* margin-bottom: 22px; */
}
.page-pagination {
	padding: 20px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/news/index.vue